import { Component, Input, OnInit } from '@angular/core';
import { ContentSectionModel } from '@app/models/content-section.model';

@Component({
  selector: 'app-content-section',
  templateUrl: './content-section.component.html',
  styleUrls: ['./content-section.component.scss']
})

export class ContentSectionComponent implements OnInit {

  @Input() section: ContentSectionModel;
  
  constructor() { }

  ngOnInit(): void { }

}
